import { render } from "./Presets.vue?vue&type=template&id=e6dd5724&ts=true"
import script from "./Presets.vue?vue&type=script&lang=ts"
export * from "./Presets.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__